import ltShoppingCartSummary from 'html/checkout/lt-shopping-cart-summary.html';
import App from 'app/app.js';
import 'app/directive/LtShoppingCartSummaryCtrl.js';

function LtShoppingCartSummaryDirective() {
  return {
    restrict: 'E',
    scope: {
      isShoppingCart: '@',
      index: '=',
      removeCouponClick: '&',
      enterCouponClick: '&',
      onContinueShopping: '&',
      getPlaceholder: '&',
      coupons: '=',
      isLoggedIn: '=',
      goToCreateAccount: '&',
      goToMyAccount: '&'
    },
    template: ltShoppingCartSummary,
    controller: 'LtShoppingCartSummaryCtrl',
    controllerAs: 'shoppingCartSummary'
  };
}

App.directive('ltShoppingCartSummary', [LtShoppingCartSummaryDirective]);
